import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import { List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import { Icon, IconButton, Grid, Card, CardContent, Tooltip, Divider, Chip } from '@material-ui/core';
import { grey } from '@material-ui/core/colors'
import { withTheme } from '@material-ui/core/styles';
import Docuement from 'composer/images/background/docuement.png';

class HotspotListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      hotspotListHeight: 0,
    };
    autoBind(this);
  }

  componentDidMount() {
    // this.props.root.setTitle("LOCALE LIST VIEW !!!!")
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.props.parent.refs.hotspotViewerBar.refs.div.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);

    if(height <= 0){
      height = window.innerHeight - (64 + window.scrollY + 56.5);
    }

    this.setState({
      hotspotListHeight: height,
    });
    this.state.hotspotListHeight = height;
  }

  render() {
    return (
      <Grid item xs={12}>
        <List style={{ height:this.state.hotspotListHeight, overflow:"auto", padding:"0", fontSize:'16px' }}>
          <If condition={this.props.parent.state.hotspotList.length > 0}>
            <Then>
              {this.props.parent.state.hotspotList.map( (row, i) => {
                return (
                  <Card variant="outlined" className="margin-std padding-sm" >
                    <CardContent className="padding-zero" style={{margin:"-5px -5px -7px -5px"}}>
                      <ListItem 
                        key={i} button
                        onClick={()=>this.props.parent.handleHotspotClicked(row)}
                        className="padding-md"
                        >
                        <If condition={row['lat'] === "0" && row['lon'] === "0"}>
                          <Then>
                            <Tooltip title={Localization.strings.NOT_POSITIONED}>
                              <ListItemIcon>
                                <Icon color="disabled">remove_circle</Icon>
                              </ListItemIcon>
                            </Tooltip>
                          </Then>
                          <Else>
                            <Tooltip title={Localization.strings.HOTSPOT_HAS_LOCATION}>
                              <ListItemIcon>
                                <Icon color="primary">check_circle</Icon>
                              </ListItemIcon>
                            </Tooltip>
                          </Else>
                        </If>
                        <Tooltip title={Localization.strings.EDIT}>
                          <ListItemText>{row['name']}</ListItemText>
                        </Tooltip>
                        <ListItemSecondaryAction>
                          <Tooltip title={Localization.strings.DELETE}>
                            <IconButton
                              onClick={()=>this.props.parent.deleteHotspotClicked(row['id'])}
                            >
                              <Icon style={{ color: grey[400] }}>delete</Icon>
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </CardContent>
                  </Card>
                )
              })}
            </Then>
            <Else>
            <img style={{display:'block',marginLeft:'auto',marginRight:'auto',height:window.screen.width>1024?'40%':'20%',width:'auto'}} src={Docuement} />
              <Card className="margin-std padding-std" style={{textAlign:'center'}}>
                <CardContent>
                  {Localization.strings.EMPTY_HOTSPOT_REMINDER}
                </CardContent>
              </Card>
            </Else>
          </If>
        </List>
      </Grid>
    )
  }
}

export default withTheme(HotspotListView);
